import React from 'react';
import { Spinner } from '@core/components';
import { useThemes } from '@core/hooks';

const PopupSpinner = () => {
  const { isDark } = useThemes();

  return (
    <div className={`popup-spinner ${isDark ? 'popup-spinner--dark' : ''}`}>
      <Spinner />
    </div>
  );
};

export default PopupSpinner;
